import { render, staticRenderFns } from "./ClientAccountDetailsView.vue?vue&type=template&id=60ae1408"
import script from "./ClientAccountDetailsView.vue?vue&type=script&lang=js"
export * from "./ClientAccountDetailsView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports